export default __webpack_public_path__ + "static/media/good2swim-logo.632ffce5.png";